import * as Constants from '../constants';
import Api from '../lib/Api';

/**
 * Actions creator to retrieve artist data
 *
 * @param {string} token - musicId, seoToken or encrypted hex token of the artist to look up
 * @returns {Promise}
 */
export function getArtist(token) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.FETCH_ARTIST,
    content: {
      token,
    },
  });
}

/**
 * Actions creator to retrieve composer data
 *
 * @param {string} token - musicId, seoToken or encrypted hex token of the composer to look up
 * @returns {Promise}
 */
export function getComposer(token) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.FETCH_COMPOSER,
    content: {
      token,
    },
  });
}

/**
 * Actions creator to retrieve album data
 *
 * @param {string} token - musicId, seoToken or encrypted hex token of the album to look up
 * @param {string} getAlbumArtist - Whether or not to get album's artist after fetch is complete
 * @returns {Promise}
 */
export function getAlbum(token, getAlbumArtist) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.FETCH_ALBUM,
    content: {
      token,
    },
    actionParams: {
      getAlbumArtist,
    },
  });
}

/**
 * Actions creator to retrieve track data
 *
 * @param {string} token - musicId, seoToken or encrypted hex token of the track to look up
 * @returns {Promise}
 */
export function getTrack(token) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.FETCH_TRACK,
    content: {
      token,
    },
  });
}

/**
 * Actions creator to retrieve full lyrics for a track
 *
 * @param {string} trackId - music ID for a track
 * @param {string} lyricId - lyricId from a lyricSnippet
 * @param {string} checksum - timestamp for caching purposes on server
 * @param {boolean} isExplicit - user setting for explicit
 * @returns {Promise}
 */
export function getFullLyrics({ trackId, lyricId, checksum, isExplicit }) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.FETCH_FULL_LYRICS,
    content: {
      trackUid: trackId,
      lyricId,
      checksum,
      nonExplicit: !isExplicit,
    },
  });
}
